import { defineNuxtPlugin } from '#app'
import { useEventListener } from '@vueuse/core'
import { type DirectiveBinding } from 'vue'

const directiveName = 'position-sticky'

interface IBinding extends DirectiveBinding {
  value: {
    top?: number
    offsetTop?: number // 可以微调实际触发吸附的距离
    scrollTarget?: HTMLElement
    // left?: number; 未支持
    // right?: number; 未支持
    // bottom?: number; 未支持
  }
}

enum DIRECTION {
  DOWN = 1,
  UP = 2,
  UNKNOWN = 9, // 没有变化
}

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.directive(directiveName, {
    mounted(el: HTMLElement, binding: IBinding) {
      const scrollTarget = binding.value.scrollTarget || document.scrollingElement
      let lastScrollTop = 0
      let targetScrollTop = 0
      let insertDiv: HTMLElement | null = null

      const getOffsetTop = () => {
        const val = el.getAttribute('data-offset-top')
        if (val) return Number(val)
        return 0
      }

      // 计算元素距离顶部的实际距离
      const calcTargetScrollTop = () => {
        const rect = el.getBoundingClientRect()
        targetScrollTop = rect.top + window.scrollY
      }

      const getDirection = (top: number, lastTop: number) => {
        if (top > lastTop) {
          return DIRECTION.DOWN
        }
        if (top < lastTop) {
          return DIRECTION.UP
        }
        return DIRECTION.UNKNOWN
      }

      const genStaticDivFromEl = () => {
        if (insertDiv === null) {
          insertDiv = document.createElement('div')
          insertDiv.style = `
            width: ${el.clientWidth}px;
            height: ${el.clientHeight}px;
          `
          el.parentElement?.insertBefore(insertDiv, el)
        }
      }

      const removeStaticDiv = () => {
        insertDiv?.remove()
        insertDiv = null
      }

      const updateFn = () => {
        const currentScrollTop = scrollTarget?.scrollTop || 0
        const dir = getDirection(currentScrollTop, lastScrollTop)

        // 向下滑动时，越过临界点后开始吸附
        if (dir === DIRECTION.DOWN && binding.value.top !== undefined) {
          if (currentScrollTop >= targetScrollTop + getOffsetTop() - binding.value.top) {
            genStaticDivFromEl()
            el.style.setProperty('position', 'fixed')
            el.style.setProperty('top', `${binding.value.top}px`)
            el.classList.add('is-fixed')
          }
        }
        // 取消吸附
        if (dir === DIRECTION.UP && binding.value.top !== undefined) {
          if (currentScrollTop < targetScrollTop + getOffsetTop() - binding.value.top) {
            removeStaticDiv()
            el.style.removeProperty('position')
            el.style.removeProperty('top')
            el.classList.remove('is-fixed')
          }
        }

        lastScrollTop = currentScrollTop
      }

      const init = () => {
        calcTargetScrollTop()
        updateFn()
      }

      useEventListener(scrollTarget?.tagName === 'HTML' ? window : scrollTarget, 'scroll', updateFn)
      useEventListener(scrollTarget?.tagName === 'HTML' ? window : scrollTarget, 'resize', calcTargetScrollTop)

      init()
    },
    updated(el, binding) {
      el.setAttribute('data-offset-top', `${binding.value.offsetTop || 0}`)
    },
  })
})
